module.exports = __webpack_public_path__ + "img/sina-scode.7e1f4e34.jpg";